import styles from "@/styles/saleEvent.module.scss"
import Head from "next/head"
import { useRouter } from 'next/router'
import { useState, useEffect } from 'react'
import DefaultLayout from "@/components/DefaultLayout"
import SliderBarLeft from "@/components/SliderBarLeft"
import SliderBarRight from "@/components/SliderBarRight"
import ShopInfo from "@/components/ShopInfo"
import { message } from 'antd'
import Image from 'next/image';
import systemApi from '@/service/modules/systemApi'

interface ImageItemProps {
  imageUrl: string;
  imageAlt?: string;
  href?: string;
  width?: string;
}
export default function SaleEvent() {
  const router = useRouter()
  const [saleData, setSaleData] = useState<any>([]);

  useEffect(() => {
    if (!router.isReady) return;

    if (router.query.eventName) {
      getSaleEvent(String(router.query.eventName))
    } else {
      router.replace('/404')
    }
  }, [router.isReady])

  // 获取当前活动信息
  const getSaleEvent = async (eventName: string) => {
    try {
      let res = await systemApi.getSaleEventData(eventName)
      if (res.data && res.data.event) {
        setSaleData(JSON.parse(res.data.event?.setting))
      }
    } catch (error: any) {
      router.replace('/404')
      message.error(error.message)
    }
  }

  const ImageItem = (item: ImageItemProps) => {
    const { imageUrl, imageAlt = imageUrl, href } = item;  // 默认值为 imageUrl
    return (
      <div className={styles['image-item-box']} style={item.width ? { width: item.width } : { width: '100%' }}>
        {href ? (
          <a href={href} target="_blank" rel="noopener noreferrer" style={{ display: 'block', height: '100%' }}>
            <Image className={styles['image-item']} src={imageUrl} alt={imageAlt} width={1200} height={500} />
          </a>
        ) : (
          <Image className={styles['image-item']} src={imageUrl} alt={imageAlt} width={1200} height={500} />
        )}
      </div>
    );
  };

  return (
    <>
      <Head>
        <title>{`Online Shopping in New Zealand: Discount Store - BestDeals.co.nz`}</title>
        <meta name="keywords" content={``}></meta>
        <meta name="description" content={`New Zealand's #1 online shopping website! Cheap bargains & discounts with the top online shopping New Zealand store! From furniture, to toys & hobbies, to appliances & pet supplies -- we've got it all, with free shipping on selected items!`}></meta>
        <meta name="format-detection" content="telephone=no" />
        <meta name="renderer" content="webkit" />
      </Head>
      <DefaultLayout >

        <div className={`${styles['page-sale-event']} slider-wapper`}>
          <SliderBarLeft></SliderBarLeft>
          <SliderBarRight></SliderBarRight>

          {/* 商城特色 */}
          {
            // <div className={styles["shop-info-box"]}>
            //   <ShopInfo hiddenContactus={true}></ShopInfo>
            // </div>
          }

          <div className={styles['sale-gallery']}>
            {saleData.map((group: any, index: number) => (
              <div key={index} className={styles['image-row']}>
                {group.map((item: any, idx: number) => (
                  <ImageItem key={idx} {...item} />
                ))}
              </div>
            ))}
          </div>

        </div>
      </DefaultLayout>
    </>
  )
}